

jQuery(document).ready(function($){
    
    
    ///////////////////////////////////
    //  Frontpage scrolldown button  //
    ///////////////////////////////////

    $("a.scrolldown-button").click(function(event){
        event.preventDefault();
                
        var id = $(this).attr('href'),
            top = $(id).offset().top;
            
        $('body,html').animate({
            scrollTop: top
        }, 1000);
    });

    
    ///////////////////////
    //  Ansatte sorting  //
    ///////////////////////

    // Initialize sortable employees
    function initMixItUp() {

        // Set up mixer object
        var mixer = mixitup('#mixitup', {
            animation: {
                duration: 300,
                effects: 'fade stagger(10ms)',
                easing: 'ease'
            },
            callbacks: {
                onMixStart: function(state) {
                    $("#no-hits p").slideUp();
                },

                onMixEnd: function(state) {
                    console.log($matching.length);
                    if ($matching.length === 0 ) {
                        $("#no-hits p").slideDown();
                    }
                },

                onMixFail: function(state) {
                    $("#no-hits p").slideDown();
                }
            }
        });

        // searchable filter
        // http://codepen.io/edprats/pen/pzAdg
        var inputText;
        var $matching = $();

        // Delay function
        var delay = (function(){
            var timer = 0;
            return function(callback, ms){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            };
        })();

        /////////////////////////
        //  Searchbox handler  //
        /////////////////////////

        $("#search-filter").keyup(function(e){

            console.log($(this).attr('id') + ' keyup triggered reset');

            // $("#select-department")[0].selectedIndex = 0;
            // $("#select-department").select2("val", "0");

            // Delay function invoked to make sure user stopped typing
            delay(function(){

                var currentValue = e.target.value;

                // reset other selections if not already reset
                if ($("#select-department")[0].selectedIndex !== 0) {
                    
                    $("#select-department")[0].selectedIndex = 0;
                    $("#select-department").select2("val", "0");    

                    // Reset this value
                    $("#search-filter").val(currentValue);
                }


                inputText = $("#search-filter").val().toLowerCase();
                
                // Check to see if input field is empty
                
                if ((inputText.length) > 0) {    

                    $('.mix').each(function() {
                        // $this = $("this");
                        
                        // add item to be filtered out if input text matches items inside the title   
                        // console.log($(this).find('.name').text() + ' - ' + inputText); // .children('.name').text().toLowerCase()
                        if($(this).find('.name').text().toLowerCase().match(inputText)) {
                            $matching = $matching.add(this);
                        }

                        else {
                            // removes any previously matched item
                            $matching = $matching.not(this);
                        }
                    });
                    
                    // Show "no results" error if no hits
                   mixer.filter($matching);    
                    
                }

                else {
                    // resets the filter to show all item if input is empty
                    // $("#mixitup").mixItUp('filter', 'all');
                    console.log('filtering all')
                    $('.mix').each(function() {$matching = $matching.add(this)});
                    mixer.filter('all');
                }
                
                // $("#mixitup").mixItUp('filter', $matching);
                
            }, 200 );
        });

        $("#select-department").change(function (e) { 
            
            var value = this.value;
            console.log("Value = " + value);
            
            // Reset other selections
            $("#search-filter").val('');
            
            // If none selected
            if (value == 0) {
                console.log("Matching all!");    
                $('.mix').each(function() {
                    $matching = $matching.add(this);
                });;
                mixer.filter('all');
            }

            else {                
                // Loop through all employees and mark for sorting
                $('.mix').each(function() {
                    if ($(this).hasClass(value)) {
                        $matching = $matching.add(this);
                    }
                    else {
                        // removes any previously matched item
                        $matching = $matching.not(this);
                    }
                });
            }

            // $("#mixitup").mixItUp('filter', $matching);
            mixer.filter($matching);
            
            /*            
            if (value == 0) { // show all
                    $('#mixitup').mixItUp('filter', 'all')
                } 
                else { // show selected
                    $('#mixitup').mixItUp('filter', '.filter-kompetanse-id-' + value)
                }

            });
            */
        });
    }


    

    // enable mixitup (sort ansatte)
    if ($('#mixitup').length > 0) {
        $('select').select2({
			minimumResultsForSearch: -1
		});
        initMixItUp();
    }
});


